export default __webpack_public_path__ + "static/media/chicken-enabled.613e1f71.webp";